import { apiClient } from '../api/client';
import type { FeatureFlag } from './types';

interface ApiResponse<T> {
  message?: string;
  data: T;
}

/**
 * Feature Flags API Service
 * Fetches feature flags for the marketplace application
 */
export const featureFlagsApi = {
  /**
   * Get all feature flags for the marketplace application
   */
  getAll: async (): Promise<FeatureFlag[]> => {
    const response = await apiClient.get<ApiResponse<FeatureFlag[]>>(
      '/public/feature-flags/marketplace'
    );
    return response.data?.data ?? [];
  },

  /**
   * Get a specific feature flag by key
   */
  getByKey: async (key: string): Promise<FeatureFlag | null> => {
    const flags = await featureFlagsApi.getAll();
    return flags.find((flag: FeatureFlag) => flag.key === key) ?? null;
  },
};
